import React, { useEffect, useState } from "react";
import TitleBar from "../../common/title-bar/title-bar";
import Button from "../../common/button/button";
import "./ReportsHome.css";
import Text from "../../common/typography/text";
import Table from "../../common/table";
import TableOptionsCell from "../../common/table/table-options-cell";
import TableLink from "../../common/table/table-link";
import dayjs from "dayjs";
import ModalView from "../../common/modal";
import TextInput from "../../common/text-input";
import NewReport from "./NewReport";
import APIService from "../../Service/APIService";
import { Flex, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useAuth } from '../AuthProvider.js';

const ReportsDashboard = () => {
  const { user } = useAuth();
  const userData = user;
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [selectedSegment, setSelectedSegment] = useState("Sales");
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openRunNewReport, setOpenRunNewReport] = useState(false);
  const [reportsData, setReportsData] = useState([]);

  const [reportName, setReportName] = useState("");

  const handleSegmentChange = (value) => {
    setSelectedSegment(value);
  };

  const tableHeadersReports = [
    {
      headerName: "Report Name",
      field: "ReportName",
      filter: true,
      cellRenderer: (params) => (
        <TableLink
          value={params.data.ReportName}
          path={`/Reports/${params.data.ID}`}
        />
      ),
    },
    {
      headerName: "Type",
      field: "Type",
      filter: true,
    },
    {
      headerName: "Date Saved",
      field: "DateSaved",
      filter: true,
      cellRenderer: (params) => dayjs(params.DateSaved).format("MM-DD-YYYY"),
    },
    {
      headerName: "Created By",
      field: "CreatedBy",
      filter: true,
    },
    {
      headerName: "Action",
      field: "",
      sortable: false,
      cellRenderer: (params) => (
        <TableOptionsCell
          optionOne="Edit"
          optionOneType="warning"
          optionOneClickFn={() => setOpenEditModal(true)}
          rowData={params.data}
        />
      ),
    },
  ];

  const handleRunNewReport = () => {
    setOpenRunNewReport(!openRunNewReport);
  };

  const getReportsDashboard = async () => {
    const apiService = new APIService();
    const response = await apiService.getDataFromBackend("GetReportsDashboard");
    setReportsData(response.data);
  };

  useEffect(() => {
    if (!userData.Reports) {
      navigate('/');
    }
    getReportsDashboard().then((data) => {
      setLoading(false);
    });
  }, []);

  return (
    <>
      {loading && (
        <Flex align="center" gap="middle">
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 48,
                }}
                spin
              />
            }
            fullscreen
          />
        </Flex>
      )}
      <div style={{ display: "flex", flexDirection: "column", gap: "32px" }}>
        <TitleBar
          label="Reports"
          filterBarComponents={
            <Button
              isActive={selectedSegment === "Sales"}
              variant="timeframe"
              onClick={() => handleSegmentChange("Sales")}
            >
              Sales
            </Button>
          }
        />

        {selectedSegment === "Sales" && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <div className="reports-container">
              <div className="reports-title-container">
                <Text variant="bodyText">Saved Reports</Text>
                <Button
                  variant="table"
                  subVariant="primary"
                  onClick={() => setOpenRunNewReport(true)}
                >
                  Run New Report
                </Button>
              </div>
            </div>
            <Table rowData={reportsData} columnDefs={tableHeadersReports} />
          </div>
        )}
      </div>
      {openEditModal && (
        <ModalView
          isOpen={openEditModal}
          onClose={() => setOpenEditModal(false)}
          modalTitle="Save Report"
          textInputComponent={
            <div className="field-group-wrapper">
              <div className="field-group">
                <TextInput
                  titleText="Report Name"
                  placeholder="Report Name"
                  parentClassName="full-width-button"
                  value={reportName}
                  isRequired
                  setValue={setReportName}
                />
              </div>
            </div>
          }
          footerButtonWrapper={
            <Button variant="table" subVariant="success">
              Save
            </Button>
          }
        />
      )}

      {openRunNewReport && (
        <NewReport
          handleRunNewReport={handleRunNewReport}
          openRunNewReport={openRunNewReport}
        />
      )}
      {/* {openRunNewReport && (
        <ModalView
          isOpen={openRunNewReport}
          onClose={() => setOpenRunNewReport(false)}
          modalTitle="All Sales Report"
          textInputComponent={
            <>
              <div className="sales-report-modal-field">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                  className="text-label"
                >
                  <Text variant="bodyText">Timeframe</Text>
                </div>

                <DropdownComponent
                  label=""
                  placeholder=""
                  options={[
                    { label: "This week", value: "week" },
                    { label: "This Month", value: "month" },
                    { label: "Last Month", value: "last-month" },
                    { label: "Custom", value: "custom" },
                  ]}
                  value={timeframe}
                  setValue={setTimeframe}
                />
                {timeframe.value === "custom" && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "16px",
                      //   backgroundColor: "rebeccapurple",
                    }}
                  >
                    <DatePickerComponent
                      format="MM-DD-YYYY"
                      titleText=""
                      value={customStartDate}
                      setValue={setCustomStartDate}
                    />
                    <Text variant="bodyText">to</Text>
                    <DatePickerComponent
                      format="MM-DD-YYYY"
                      titleText=""
                      value={customEndDate}
                      setValue={setCustomEndDate}
                    />
                  </div>
                )}
              </div>

              <div
                className="sales-report-modal-field"
                style={{ alignSelf: "stretch" }}
              >
                <div className="text-label">
                  <Text variant="bodyText">Regions</Text>
                </div>
                <div className="text-input">
                  <MultiSelectInput
                    placeholder="All Regions"
                    value={region}
                    setValue={setRegion}
                    options={[
                      { label: "North Atlantic", value: "north-atlantic" },
                      { label: "South Atlantic", value: "south-atlantic" },
                      { label: "Pacific West", value: "pacific-west" },
                      { label: "South Central", value: "south-central" },
                      { label: "North Central", value: "north-central" },
                    ]}
                    labelKey="label"
                    labelValue="value"
                  />
                </div>
              </div>
              <div
                className="sales-report-modal-field"
                style={{ alignSelf: "stretch" }}
              >
                <div className="text-label">
                  <Text variant="bodyText">Manufacturers</Text>
                </div>
                <div className="text-input">
                  <MultiSelectInput
                    placeholder="All Manufacturers"
                    value={region}
                    setValue={setRegion}
                    options={[
                      { label: "North Atlantic", value: "north-atlantic" },
                      { label: "South Atlantic", value: "south-atlantic" },
                      { label: "Pacific West", value: "pacific-west" },
                      { label: "South Central", value: "south-central" },
                      { label: "North Central", value: "north-central" },
                    ]}
                    labelKey="label"
                    labelValue="value"
                  />
                </div>
              </div>
              <div
                className="sales-report-modal-field"
                style={{ alignSelf: "stretch" }}
              >
                <div className="text-label">
                  <Text variant="bodyText">Products</Text>
                </div>
                <div className="text-input">
                  <MultiSelectInput
                    placeholder="All Products"
                    value={region}
                    setValue={setRegion}
                    options={[
                      { label: "North Atlantic", value: "north-atlantic" },
                      { label: "South Atlantic", value: "south-atlantic" },
                      { label: "Pacific West", value: "pacific-west" },
                      { label: "South Central", value: "south-central" },
                      { label: "North Central", value: "north-central" },
                    ]}
                    labelKey="label"
                    labelValue="value"
                  />
                </div>
              </div>
              <div
                className="sales-report-modal-field"
                style={{ alignSelf: "stretch" }}
              >
                <div className="text-label">
                  <Text variant="bodyText">Distributors</Text>
                </div>
                <div className="text-input">
                  <MultiSelectInput
                    placeholder="All Distributors"
                    value={region}
                    setValue={setRegion}
                    options={[
                      { label: "North Atlantic", value: "north-atlantic" },
                      { label: "South Atlantic", value: "south-atlantic" },
                      { label: "Pacific West", value: "pacific-west" },
                      { label: "South Central", value: "south-central" },
                      { label: "North Central", value: "north-central" },
                    ]}
                    labelKey="label"
                    labelValue="value"
                  />
                </div>
              </div>
              <div
                className="sales-report-modal-field"
                style={{ alignSelf: "stretch" }}
              >
                <div className="text-label">
                  <Text variant="bodyText">Accounts</Text>
                </div>
                <div className="text-input">
                  <MultiSelectInput
                    placeholder="All Accounts"
                    value={region}
                    setValue={setRegion}
                    options={[
                      { label: "North Atlantic", value: "north-atlantic" },
                      { label: "South Atlantic", value: "south-atlantic" },
                      { label: "Pacific West", value: "pacific-west" },
                      { label: "South Central", value: "south-central" },
                      { label: "North Central", value: "north-central" },
                    ]}
                    labelKey="label"
                    labelValue="value"
                  />
                </div>
              </div>
              <div
                className="sales-report-modal-field"
                style={{ alignSelf: "stretch" }}
              >
                <div className="text-label">
                  <Text variant="bodyText">Order Type</Text>
                </div>
                <div className="text-input">
                  <MultiSelectInput
                    placeholder="Direct Order / Product Usage"
                    value={region}
                    setValue={setRegion}
                    options={[
                      { label: "Direct Order", value: "direct-order" },
                      { label: "Product Usage", value: "product-usage" },
                    ]}
                    labelKey="label"
                    labelValue="value"
                  />
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      marginTop: "12px",
                    }}
                  >
                    <Checkbox style={{ transform: "scale(1.25)" }} />
                    <Text variant="bodyText">
                      Include only realized sales — orders which are invoiced
                    </Text>
                  </div>
                </div>
              </div>
              <div
                className="sales-report-modal-field"
                style={{ alignSelf: "stretch" }}
              >
                <div className="text-label">
                  <Text variant="bodyText">Invoice Status</Text>
                </div>
                <div className="text-input">
                  <MultiSelectInput
                    placeholder="Open Balance / Past Due / Fully Paid"
                    value={region}
                    setValue={setRegion}
                    options={[
                      { label: "Open Balance", value: "open-balance" },
                      { label: "Past Due", value: "past-due" },
                      { label: "Fully Paid", value: "fully-paid" },
                    ]}
                    labelKey="label"
                    labelValue="value"
                  />
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      marginTop: "12px",
                    }}
                  >
                    <Checkbox style={{ transform: "scale(1.25)" }} />
                    <Text variant="bodyText">Include voided invoices</Text>
                  </div>
                </div>
              </div>
            </>
          }
          footerButtonWrapper={
            <div className="footer-button-wrapper">
              <Button variant="table" subVariant="primary">
                Run Report
              </Button>
            </div>
          }
        />
      )} */}
    </>
  );
};

export default ReportsDashboard;
